import { render, staticRenderFns } from "./music-update.vue?vue&type=template&id=b2a90ea6&scoped=true&"
import script from "./music-update.vue?vue&type=script&lang=js&"
export * from "./music-update.vue?vue&type=script&lang=js&"
import style0 from "./music-update.vue?vue&type=style&index=0&lang=less&"
import style1 from "./music-update.vue?vue&type=style&index=1&id=b2a90ea6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a90ea6",
  null
  
)

export default component.exports